"use client";

import { useState, useEffect, useRef } from "react";
import styles from "../works.module.scss";

export default function MetricsRow() {
  const [counted, setCounted] = useState(false);
  const metricsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !counted) {
            setCounted(true);
            // Count up animation
            const counters =
              entry.target.querySelectorAll<HTMLElement>("[data-target]");
            counters.forEach((counter) => {
              const target = parseFloat(
                counter.getAttribute("data-target") || "0"
              );
              const suffix = counter.getAttribute("data-suffix") || "";
              const duration = 2000;
              const start = Date.now();
              const startValue = 0;

              const animate = () => {
                const now = Date.now();
                const elapsed = now - start;
                const progress = Math.min(elapsed / duration, 1);
                const current = startValue + (target - startValue) * progress;

                if (suffix === "+") {
                  counter.textContent = Math.floor(current) + suffix;
                } else if (suffix === "x") {
                  counter.textContent = current.toFixed(1) + suffix;
                } else {
                  counter.textContent = Math.floor(current) + suffix;
                }

                if (progress < 1) {
                  requestAnimationFrame(animate);
                }
              };

              animate();
            });
          }
        });
      },
      { threshold: 0.5 }
    );

    const el = metricsRef.current;
    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, [counted]);

  return (
    <div className={`${styles.metricsRow} fade-up`} ref={metricsRef}>
      <div className={styles.metricItem}>
        <span className={styles.metricVal}>
          <span data-target="146" data-suffix="+">
            0
          </span>
        </span>
        <span className={styles.metricLabel}>支援実績数</span>
      </div>
      <div className={styles.metricItem}>
        <span className={styles.metricVal}>
          <span data-target="93" data-suffix="%">
            0
          </span>
        </span>
        <span className={styles.metricLabel}>継続率</span>
      </div>
      <div className={styles.metricItem}>
        <span className={styles.metricVal}>
          <span data-target="200" data-suffix="%">
            0
          </span>
        </span>
        <span className={styles.metricLabel}>平均ROI改善</span>
      </div>
    </div>
  );
}
